var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    _vm._b(
      {
        attrs: { "data-test": _vm.CypressTarget("UserEditPage"), padding: "" }
      },
      "q-page",
      _vm.__cordovaFixQPageBind,
      false
    ),
    [
      _c("div", { staticClass: "row justify-start gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6" },
          [
            _c(
              "q-card",
              {
                staticClass: "relative-position",
                attrs: { "data-test": _vm.CypressTarget("UserCard") }
              },
              [
                _c("q-card-title", [_vm._v(_vm._s(_vm.$t("label.userData")))]),
                _c(
                  "q-card-main",
                  [
                    _c(_vm.identificationForm.user, {
                      ref: "userForm",
                      tag: "component",
                      attrs: {
                        value: _vm.getUserInformation,
                        "can-edit-cpf": _vm.canEditCPF,
                        "can-edit-name": _vm.canEditName,
                        "can-edit": true,
                        "edit-mode": true,
                        "imperial-system": _vm.isImperialSystem
                      },
                      on: {
                        input: function($event) {
                          _vm.userData.information = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-inner-loading",
                  { attrs: { visible: _vm.loading } },
                  [
                    _c("q-spinner", {
                      attrs: { color: _vm.SET_COLOR.primary, size: "50px" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "opt-in-specific-fields" },
              [
                _c("form-user-extra", {
                  ref: "extraForm",
                  attrs: {
                    value: _vm.getUserExtras,
                    "can-edit": true,
                    "edit-mode": true,
                    "unchecked-fields": false
                  },
                  on: {
                    input: function($event) {
                      _vm.userData.extra = $event
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6" },
          [
            _c(
              "q-card",
              {
                staticClass: "relative-position",
                attrs: { "data-test": _vm.CypressTarget("AddressCard") }
              },
              [
                _c("q-card-title", [
                  _vm._v(_vm._s(_vm.$t("label.userAddress")))
                ]),
                _c(
                  "q-card-main",
                  [
                    _c(_vm.identificationForm.address, {
                      ref: "addressForm",
                      tag: "component",
                      attrs: {
                        value: _vm.getUserAddress,
                        "can-edit": true,
                        "edit-mode": true
                      },
                      on: {
                        input: function($event) {
                          _vm.userData.address = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-inner-loading",
                  { attrs: { visible: _vm.loading } },
                  [
                    _c("q-spinner", {
                      attrs: { color: _vm.SET_COLOR.primary, size: "50px" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "row items-end col-12",
            class: {
              "justify-end": _vm.$q.platform.is.desktop,
              "justify-center": _vm.$q.platform.is.mobile
            },
            attrs: { "data-test": _vm.CypressTarget("Buttons") }
          },
          [
            _c("div", { staticClass: "col-xs-12 col-md-6 row gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("q-btn", {
                    directives: [
                      {
                        name: "go-back",
                        rawName: "v-go-back.single",
                        value: "/",
                        expression: " '/' ",
                        modifiers: { single: true }
                      }
                    ],
                    staticClass: "full-width",
                    attrs: {
                      "data-test": _vm.CypressTarget("Cancel"),
                      label: _vm.$t("button.cancel"),
                      color: "negative",
                      icon: "cancel"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      "data-test": _vm.CypressTarget("Ok"),
                      label: _vm.$t("button.update"),
                      loading: _vm.loading,
                      color: "positive",
                      icon: "edit"
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.updateUser($event)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }